import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdateEmailAlertGroupInterface {
  partnerId?: string
  currentServiceName?: string
  serviceName?: string
  serviceNameDescription?: string
  tag?: string
}

export const useUpdateEmailAlertGroup = () => {
  const mutate = useMutation(
    ({
      partnerId,
      currentServiceName,
      serviceName,
      serviceNameDescription,
      tag,
    }: UpdateEmailAlertGroupInterface) => {
      return putAPI('/NotificationRecipientGroup', {
        group: {
          partnerId: partnerId,
          currentServiceName: currentServiceName,
          serviceName: serviceName,
          serviceNameDescription: serviceNameDescription,
          tag: tag,
        },
      })
    },
  )

  return mutate
}

export default useUpdateEmailAlertGroup
